// extracted by mini-css-extract-plugin
export default {"parent-container":"CreateUser_parent-container__Aqljc","patient-list":"CreateUser_patient-list__p-oJ7","newFormUsersOnly":"CreateUser_newFormUsersOnly__Oi++S"};